import { render } from "./fileshow.vue?vue&type=template&id=afdddcde"
import script from "./fileshow.vue?vue&type=script&lang=js"
export * from "./fileshow.vue?vue&type=script&lang=js"

import "./fileshow.vue?vue&type=style&index=0&id=afdddcde&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__